//A common function to add properties as "super"(mix-panel) and they can be used everywhere on every event fire in web-ui
const trackAnalyticsEventFromWeb = typeof trackAnalyticsEvent !== "undefined" ? trackAnalyticsEvent : function(){};

// const getCookie = (key) => {
//   var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
//   return keyValue ? keyValue[2] : null;
// }

const addPropertiesAsSuperToTracker = (newSuperProperties) => {
  // merging super properties added till now, with new properties
  window.totalSuperProperties = {...window.totalSuperProperties, ...newSuperProperties};
  // overwriting the trackAnalyticsEvent with new function with same behaviour except it will now have the super properties as well
  trackAnalyticsEvent = trackAnalyticsEventWithSuper(totalSuperProperties);

}
const trackAnalyticsEventWithSuper = (totalSuperProperties) => {
  return (_event, properties, ...restArgs) => {
    // Assuming properties is always the second argument, taking rest arguments as it is.
    let propertiesWithSuperProps = {...properties, ...totalSuperProperties}
    trackAnalyticsEventFromWeb(_event, propertiesWithSuperProps, ...restArgs)
  }
}

export default addPropertiesAsSuperToTracker;